import { connect } from '@atlassian/jira-react-redux';
import { cancel, deleteVersion } from '../../state/actions';
import { isSwapValid, isInProgress } from '../../state/selectors';
import type { State } from '../../state/types';
import Footer from './view';

const mapStateToProps = (state: State) => ({
	isDeleteEnabled: isSwapValid(state),
	isDeleteInProgress: isInProgress(state),
});

const mapDispatchToProps = {
	onCancel: cancel,
	onDelete: deleteVersion,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
